import { useState, useEffect, useMemo } from "react";
import { useMsal } from '@azure/msal-react';
import XeroApi from "../../api/xero/xero-api-factory";
import { FlippableCard } from "../reusable-elements/flippable-card";
import { SingleStat } from "../reusable-elements/single-stat";
import { BankBalanceTrend } from "./bank-balance-trend";

export const BankBalanceCard = () => {
    const { instance, inProgress, accounts } = useMsal();
    const xeroApi = useMemo(() => new XeroApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);
    
    const [shouldFetchBalanceData, setShouldFetchBalanceData] = useState(true);
    const [balanceData, setBalanceData] = useState(null);
    const [bankSnapshots, setBankSnapshots] = useState(null);
    const [fetchingBalanceData, setFetchingBalanceData] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchData() {
            if (shouldFetchBalanceData && !fetchingBalanceData) {
                setFetchingBalanceData(true);
                setError(null);
                try {
                    const data = await xeroApi.getBankBalances();
                    setBalanceData(data);
                    const snapshots = await xeroApi.getBalanceSnapshots();
                    setBankSnapshots(snapshots);
                } catch (error) {
                    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                        setError("You don't have permission to access bank balance data");
                    } else {
                        setError("Failed to fetch bank balance data");
                        console.error("Error fetching bank balances:", error);
                    }
                } finally {
                    setShouldFetchBalanceData(false);
                    setFetchingBalanceData(false);
                }
            }
        }
        fetchData();
    }, [xeroApi, fetchingBalanceData, shouldFetchBalanceData]);

    return (
        <FlippableCard
            frontContent={
                <SingleStat
                    headerTitle="TOTAL BANK BALANCE"
                    summaryValue={`£${balanceData && balanceData.total ? balanceData.total.toFixed(2) : "0.00"}`}
                    summaryValueColour="text-green-500"
                    loading={fetchingBalanceData}
                    complete={!!!shouldFetchBalanceData}
                    error={error}
                />
            }
            backContent={
                <BankBalanceTrend bankSnapshots={bankSnapshots} />
            }
        />
    );
};